import { useCallback, useEffect, useRef, useState } from "react";

export const useQuantitySelector = (
	max: number,
	onChange: (value: number) => void,
	initValue: number
) => {
	const [value, setValue] = useState<number>(initValue);
	// Skip the implicit onChange that would otherwise fire on the initial mount
	// (when the useEffect below runs once with the initial value). User clicks
	// after the first render propagate synchronously — no 200ms blackhole.
	const isFirstRender = useRef(true);

	// Sync value when initValue changes (e.g., when item becomes out of stock)
	useEffect(() => {
		setValue(initValue);
	}, [initValue]);

	const increase = useCallback(() => {
		setValue((prev) => {
			return prev >= max ? prev : prev + 1;
		});
	}, [max]);

	const decrease = useCallback(() => {
		setValue((prev) => {
			return prev <= 0 ? 0 : prev - 1;
		});
	}, []);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;

			return;
		}
		onChange(value);
	}, [value]);

	return {
		value,
		increase,
		decrease,
	};
};
